import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import EmailGateModal from "@/components/feature/EmailGateModal";

export default function CTAFooterSection() {
  const { isAuthenticated } = useAuth();
  const [showEmailGate, setShowEmailGate] = useState(false);

  return (
    <section className="relative w-full overflow-hidden">
      {/* CTA area */}
      <div className="relative w-full py-20 md:py-28 flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="/img/readdy/8fb27bd7318e.jpg"
            alt="Você não precisa caminhar sozinha"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/45" />
        </div>

        {/* Colonial arch decoration */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-72 h-14 border-2 border-b-0 border-white/10 rounded-t-full hidden md:block" />

        <div className="relative z-10 text-center px-6">
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-white leading-tight max-w-3xl mx-auto mb-6">
            Você não precisa caminhar sozinha
          </h2>
          <p className="font-body text-base md:text-lg text-white/80 max-w-xl mx-auto mb-10 leading-relaxed">
            Faça parte de uma comunidade que acolhe, apoia e caminha junto.
            Cada passo dado em conjunto nos torna mais fortes.
          </p>
          {isAuthenticated ? (
            <Link
              to="/cadastro"
              className="inline-block font-body text-sm md:text-base px-10 py-4 rounded-full bg-primary text-white tracking-wide uppercase transition-all duration-300 hover:bg-primary-dark hover:scale-[1.02] whitespace-nowrap"
            >
              Entrar para o Entre Elas
            </Link>
          ) : (
            <button
              onClick={() => setShowEmailGate(true)}
              className="inline-block font-body text-sm md:text-base px-10 py-4 rounded-full bg-primary text-white tracking-wide uppercase transition-all duration-300 hover:bg-primary-dark hover:scale-[1.02] whitespace-nowrap cursor-pointer"
            >
              Entrar para o Entre Elas
            </button>
          )}
        </div>
      </div>

      <EmailGateModal isOpen={showEmailGate} onClose={() => setShowEmailGate(false)} />

      {/* Footer */}
      <footer className="w-full bg-nude py-12 md:py-16 relative">
        {/* Colonial bottom ornament */}
        <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-brown/15 to-transparent" />
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-6xl mx-auto relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8 mb-10">
            <div>
              <h3 className="font-display text-xl text-brown mb-4">Entre Elas</h3>
              <p className="font-body text-sm text-brown/60 leading-relaxed">
                Uma comunidade de mulheres unidas pela fé, apoio mútuo e
                crescimento conjunto. Juntas somos mais fortes.
              </p>
            </div>
            <div>
              <h4 className="font-body text-xs text-brown/50 uppercase tracking-wider mb-4">
                Navegação
              </h4>
              <div className="flex flex-col gap-2">
                <button
                  onClick={() => {
                    const el = document.getElementById("sobre");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="font-body text-sm text-brown/70 text-left hover:text-primary transition-colors whitespace-nowrap"
                >
                  Sobre o projeto
                </button>
                <button
                  onClick={() => {
                    const el = document.getElementById("galeria");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="font-body text-sm text-brown/70 text-left hover:text-primary transition-colors whitespace-nowrap"
                >
                  Galeria de eventos
                </button>
                <Link
                  to="/comunidade"
                  className="font-body text-sm text-brown/70 text-left hover:text-primary transition-colors whitespace-nowrap"
                >
                  Comunidade
                </Link>
                <Link
                  to="/cadastro"
                  className="font-body text-sm text-brown/70 text-left hover:text-primary transition-colors whitespace-nowrap"
                >
                  Cadastro
                </Link>
              </div>
            </div>
            <div>
              <h4 className="font-body text-xs text-brown/50 uppercase tracking-wider mb-4">
                Redes Sociais
              </h4>
              <div className="flex items-center gap-3">
                <a
                  href="https://www.instagram.com/entreelas.community_/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white text-brown hover:bg-primary hover:text-white transition-colors duration-300"
                >
                  <i className="ri-instagram-line" />
                </a>
              </div>
            </div>
            <div>
              <h4 className="font-body text-xs text-brown/50 uppercase tracking-wider mb-4">
                Contato
              </h4>
              <div className="flex flex-col gap-2">
                <a
                  href="https://wa.me/15619399706"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-body text-sm text-brown/70 text-left hover:text-primary transition-colors whitespace-nowrap inline-flex items-center gap-1.5"
                >
                  <i className="ri-whatsapp-line" />
                  Falar no WhatsApp
                </a>
                <a
                  href="mailto:ana@allbridgesolutions.pro"
                  className="font-body text-sm text-brown/70 text-left hover:text-primary transition-colors whitespace-nowrap"
                >
                  ana@allbridgesolutions.pro
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-nude pt-6 text-center">
            <p className="font-body text-xs text-brown/40">
              © {new Date().getFullYear()} Entre Elas. Todos os direitos
              reservados. Feito com fé e propósito.
            </p>
            <p className="font-body text-xs text-brown/40 mt-2">
              Este site usa o Pixel da Meta para medir visitas e mostrar nossos anúncios no Instagram e no Facebook.
            </p>
          </div>
        </div>
      </footer>
    </section>
  );
}